// extracted by mini-css-extract-plugin
module.exports = {"section":"FAQSection_section__9E3r3","col1":"FAQSection_col1__1S8zE"};